import { SearchSortBy, SearchSortDirection, SearchSortByField } from '../types';

export const defaultDirectionForSort = (
  sortBy: SearchSortBy,
): [SearchSortByField, SearchSortDirection] | [] => {
  switch (sortBy) {
    case 'firstName':
      return ['firstName', 'asc'];
    case 'lastName':
      return ['lastName', 'asc'];
    case 'firstInteraction':
      return ['firstInteractionDate', 'asc'];
    case 'lastInteraction':
      return ['lastInteractionDate', 'desc'];
    case 'created':
      return ['created', 'desc'];
    case 'closeness':
      return ['score', 'desc'];
    case 'archive_date':
      return ['archive_date', 'desc'];
    default:
      return [];
  }
};

export const applySortStateToObj = (
  obj: any,
  sortBy: SearchSortBy = 'closeness',
  direction?: SearchSortDirection,
) => {
  const [sort_by, defaultDirection] = defaultDirectionForSort(sortBy);

  if (sort_by) {
    return { ...obj, name: sort_by, direction: direction || defaultDirection };
  }

  return obj;
};
